import { render, staticRenderFns } from "./ModalDeleteCategory.vue?vue&type=template&id=f80c563a&"
import script from "./ModalDeleteCategory.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports